import { LicenseType } from '../interfaces'

export const getNodeNameByType = (type: LicenseType) => {
  switch (type) {
    case LicenseType.MGA_INODE:
      return 'iNODE'
    case LicenseType.MGA_LIGHT:
      return 'ggNODE'
    case LicenseType.MGA_REGULAR:
      return 'MGA'
    default:
      return ''
  }
}
